import { render } from "./page-home.vue?vue&type=template&id=5d4687ef&scoped=true"
import script from "./page-home.vue?vue&type=script&lang=js"
export * from "./page-home.vue?vue&type=script&lang=js"

import "./page-home.vue?vue&type=style&index=0&id=5d4687ef&scoped=true&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Gestion conge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4687ef"]])

export default __exports__